import { render, staticRenderFns } from "./DYGoodHot.vue?vue&type=template&id=352a8a94&scoped=true"
import script from "./DYGoodHot.vue?vue&type=script&lang=js"
export * from "./DYGoodHot.vue?vue&type=script&lang=js"
import style0 from "./DYGoodHot.vue?vue&type=style&index=0&id=352a8a94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a8a94",
  null
  
)

export default component.exports